const styles = {
  container: {
    width: '100%'
  },
  createButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 2
  }
}

export default styles
